import type { FC } from "react";
import React from "react";

import { GoogleSigninButton } from "./GoogleSigninButton.tsx";

export const SigninView: FC = () => (
  <div className="flex flex-1 items-center justify-center">
    <GoogleSigninButton />
  </div>
);
